export enum ViewMode {
  Week = 'week',
  Month = 'month',
  Year = 'year',
}

export enum ApiViewMode {
  Week = 'Week',
  Month = 'Month',
  Year = 'Year',
}

export enum ActivityType {
  Spray = 'spray',
  Dry = 'dry',
  Fertigation = 'fert',
}

export enum ActivityStatus {
  Completed = 'completed',
  Planned = 'planned',
}
